import { render, staticRenderFns } from "./SelectableRole.vue?vue&type=template&id=033ebd3c&scoped=true"
import script from "./SelectableRole.vue?vue&type=script&lang=js"
export * from "./SelectableRole.vue?vue&type=script&lang=js"
import style0 from "./SelectableRole.vue?vue&type=style&index=0&id=033ebd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033ebd3c",
  null
  
)

export default component.exports